import md from '@/router/middlewares';
import type { RouteRecordRaw } from 'vue-router';
import roles from '@/constants/roles';
import { TYPE_EVENT_MANAGEMENT } from '@/aquassist-shared/constants/types/features';
import store from '@/store';

const services: RouteRecordRaw = {
    path: '/services',
    name: 'services',
    component: () => import('@/views/services/ServiceMain.vue'),
    redirect: { name: 'services-work-orders' },
    meta: {
        middlewares: [md.auth, md.accessControl],
    },
    children: [
        {
            meta: {
                title: 'workOrders.pageName',
                img: 'WorkOrder.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.SERVICE_TECHNICIAN.value,
                    roles.LABORATORY_CHEMIST.value,
                    roles.SALES_MANAGER.value,
                    roles.SALES_REPRESENTATIVE.value,
                    roles.SERVICE_TECHNICIAN.value,
                ],
            },
            path: 'work-orders',
            name: 'services-work-orders',
            component: () => import('@/views/services/servicesPages/ServiceWorkOrders.vue'),
        },
        {
            meta: {
                title: 'workOrdersTemplate.pageName',
                img: 'WorkOrderTemplate.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.SALES_MANAGER.value,
                    roles.SALES_REPRESENTATIVE.value,
                    roles.SERVICE_TECHNICIAN.value,
                ],
            },
            path: 'work-order-templates',
            name: 'services-work-order-templates',
            component: () => import('@/views/workOrders/template/WorkOrdersTemplate.vue'),
        },
        {
            meta: {
                title: 'eventManagement.pageName',
                img: 'Calendar.svg',
                featureFlag: TYPE_EVENT_MANAGEMENT,
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.SERVICE_TECHNICIAN.value,
                    roles.LABORATORY_CHEMIST.value,
                    roles.SALES_MANAGER.value,
                    roles.SALES_REPRESENTATIVE.value,
                ],
            },
            path: 'event-management',
            name: 'services-event-management',
            component: () => import('@/views/services/eventManagement/event.vue'),
            beforeEnter: async (_to, _from, next) => {
                if (!store.getters.showEventManagementByFeature) {
                    const teamId =
                        store.getters.currentTeamId || window.$cookies?.get('currentTeamId');
                    if (teamId) {
                        await store.dispatch('reloadTeam', teamId);
                    }
                }
                if (!store.getters.showEventManagementByFeature) {
                    next({ name: 'services-work-orders' });
                } else {
                    next();
                }
            },
        },
        {
            meta: {
                title: 'services.billing',
                hasChildren: true,
                img: 'Billing.svg',
                allowedRoles: [
                    roles.ADMINISTRATOR.value,
                    roles.MANAGER.value,
                    roles.LABORATORY_MANAGER.value,
                    roles.LABORATORY_TECHNICIAN.value,
                    roles.SALES_MANAGER.value,
                ],
            },
            path: 'billing',
            name: 'services-billing',
            children: [
                {
                    meta: {
                        title: 'services.fieldServiceBilling',
                        prependIcon: 'mdi-clipboard-edit-outline',
                        allowedRoles: [
                            roles.ADMINISTRATOR.value,
                            roles.MANAGER.value,
                            roles.SALES_MANAGER.value,
                        ],
                    },
                    path: 'field-services',
                    name: 'services-field-services',
                    component: () => import('@/views/billing/fieldServiceBilling.vue'),
                },
                {
                    meta: {
                        title: 'services.billingLaboratory',
                        prependIcon: 'mdi-flask-outline',
                        allowedRoles: [
                            roles.ADMINISTRATOR.value,
                            roles.MANAGER.value,
                            roles.LABORATORY_MANAGER.value,
                            roles.LABORATORY_TECHNICIAN.value,
                            roles.LABORATORY_CHEMIST.value,
                            roles.LABORATORY_MICROBIOLOGIST.value,
                            roles.SALES_MANAGER.value,
                        ],
                    },
                    path: 'field-laboratory',
                    name: 'services-billing-laboratory',
                    component: () => import('@/views/billing/laboratoryBilling.vue'),
                },
            ],
        },
    ],
};

export default services;
